import { render } from "./BookDiv.vue?vue&type=template&id=48046b76&scoped=true&ts=true"
import script from "./BookDiv.vue?vue&type=script&lang=ts"
export * from "./BookDiv.vue?vue&type=script&lang=ts"

import "./BookDiv.vue?vue&type=style&index=0&id=48046b76&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48046b76"]])

export default __exports__